import { Box, Checkbox, FormControlLabel } from "@mui/material";
import SetupCC from "components/setupCC";
import InputField from "components/ui/inputField";
import { HiOutlineCheckBadge } from "react-icons/hi2";
import * as yup from "yup";

const AdmissionStatuses = () => {
  const initialValues = {
    name: "",
    serial: "",
    color: "",
    is_final: false,
  };
  return (
    <SetupCC
      shouldReload
      name="Admission Status"
      baseRouteKey="admissionStatuses"
      moduleKey="admission-status"
      columns={[
        { id: "name", label: "Name", minWidth: 100 },
        { id: "serial", label: "Serial", align: "center" },
        { id: "color", label: "Status Color", align: "center" },
        {
          id: "action",
          label: "Actions",
          style: { width: "150px" },
          align: "center",
        },
      ]}
      actions={["edit", "delete"]}
      conditionalColumns={(row, column, value) => {
        return (
          <>
            {column?.id === "color" ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    bgcolor: value,
                    height: "20px",
                    width: "20px",
                    borderRadius: "5px",
                  }}
                ></Box>
              </Box>
            ) : column?.id === "name" ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                {value}
                {!!row.is_final && (
                  <Box sx={{ color: "green", fontSize: "15px" }}>
                    <HiOutlineCheckBadge />
                  </Box>
                )}
              </Box>
            ) : (
              value
            )}
          </>
        );
      }}
      getInitialValues={(data) => {
        if (data?.id) {
          let obj = {};
          for (const key in initialValues) {
            obj[key] = data[key];
          }
          return obj;
        } else return initialValues;
      }}
      validationSchema={yup.object({
        name: yup.string().required("Name is required!"),
      })}
      allFields={(formik) => (
        <>
          <InputField name="name" label="Status Name" formik={formik} />
          <InputField
            name="serial"
            label="Serial"
            inputProps={{ min: 1 }}
            formik={formik}
          />
          <InputField
            label="Status Color"
            name="color"
            type="color"
            formik={formik}
            InputLabelProps={{ shrink: true }}
          />
          <FormControlLabel
            control={<Checkbox />}
            label="Is Final?"
            checked={formik.values.is_final}
            onChange={(e) => formik.setFieldValue("is_final", e.target.checked)}
          />
        </>
      )}
    ></SetupCC>
  );
};

export default AdmissionStatuses;
